// src/pages/admin/RecipeModerationPage.tsx
import React, { useEffect, useState } from 'react';
import fetchWithAuth from '../../utils/fetchWithAuth';

type Group = { userId: string; _count: { _all: number } };

export default function RecipeModerationPage() {
  const [data, setData] = useState<Group[]>([]);
  useEffect(() => {
    fetchWithAuth('/api/admin/moderation/recipes').then(setData);
  }, []);
  return (
    <>
      <h1 className="text-xl font-bold mb-4">Recipes by User</h1>
      <table className="w-full table-auto">
        <thead>
          <tr>
            <th>User ID</th>
            <th># Recipes</th>
          </tr>
        </thead>
        <tbody>
          {data.map((g) => (
            <tr key={g.userId} className="border-t">
              <td className="p-2">{g.userId}</td>
              <td className="p-2">{g._count._all}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
